import { render, staticRenderFns } from "./CouponStockCard.vue?vue&type=template&id=12ef294c&scoped=true&"
import script from "./CouponStockCard.vue?vue&type=script&lang=js&"
export * from "./CouponStockCard.vue?vue&type=script&lang=js&"
import style0 from "./CouponStockCard.vue?vue&type=style&index=0&id=12ef294c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ef294c",
  null
  
)

export default component.exports